import BaseRegulation from '../base_regulation';
import TempAccountMessageRegulationHelper from '../../helpers/temp_account_message_helper';
import { GNWP_SOURCES } from '../../../../components/external_links/external_links_consts';

class ItalyRegulation extends BaseRegulation {

	static CLASS = 'ItalyRegulation';


	/**
	 *
	 * @param params
	 */
	init(params) {
		super.init(params);
		this._tempAccountMessageHelper = params.tempAccountMessageHelper || TempAccountMessageRegulationHelper.create({
			serviceFactory: this.serviceFactory
		});
	}

	_tempAccountMessageHelper;

	showTempAccountMessage(closeFunc) {
        this._tempAccountMessageHelper.showTempAccountMessage({
			closeFunc: closeFunc,
			messageKey: 'it_temp_account_message',
			footerMessageKey: 'it_temp_account_footer_message',
			titleKey: 'temp_account_title',
			btnNameKey: 'temp_account_upload_btn'
		});
	}

	getExternalLinksConfig() {
        return {
            'upload_document': {
                isCloseBtnAllowed: false
            }
        };
    }

    getTempAccountGnwpSource() {
        return GNWP_SOURCES.DOCUMENT_UPLOAD;
    }

	forceIntermediatePageForAutorizedUsers() {
		return false;
	}
}

export default ItalyRegulation;
